// Privacy Policy modal for the job application consent field.
// Intercepts clicks on the Privacy Policy link inside the GF consent field and
// loads the privacy page content into a native <dialog> (#privacy-modal,
// single-careers.twig) instead of navigating. showModal() handles top-layer
// rendering, Esc, and focus. All elements are resolved at interaction time so
// htmx-boosted page swaps never leave stale references — on pages without the
// dialog the link navigates normally.

function getDialog(): HTMLDialogElement | null {
  const el = document.getElementById("privacy-modal");
  return el instanceof HTMLDialogElement ? el : null;
}

function openModal(dialog: HTMLDialogElement, href: string): void {
  const content = document.getElementById("privacy-modal-content");
  const panel = document.getElementById("privacy-modal-panel");

  // Backdrop only while loading; the panel appears once content is in.
  panel?.setAttribute("hidden", "");
  const reveal = (): void => {
    if (!dialog.open) return; // closed while loading
    panel?.removeAttribute("hidden");
    dialog.querySelector<HTMLButtonElement>("#privacy-modal-close")?.focus();
  };

  // Load privacy page via fetch, extract <main> or <body> inner content.
  fetch(href)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const main = doc.querySelector("main") ?? doc.querySelector(".entry-content") ?? doc.body;
      if (content) content.innerHTML = main.innerHTML;
      reveal();
    })
    .catch(() => {
      if (content) {
        content.innerHTML = `<p><a href="${href}" target="_blank" rel="noopener">Open Privacy Policy</a></p>`;
      }
      reveal();
    });

  dialog.showModal();
  document.body.style.overflow = "hidden";
  dialog.addEventListener(
    "close",
    () => {
      document.body.style.overflow = "";
    },
    { once: true }
  );
}

document.addEventListener("click", (e) => {
  const target = e.target as HTMLElement;

  // Privacy Policy link inside a GF consent field
  // (`.ginput_container_consent label a` or `.gfield_consent_description a`).
  const link = target.closest<HTMLAnchorElement>(
    ".ginput_container_consent a, .gfield_consent_description a"
  );
  if (link?.href) {
    const dialog = getDialog();
    if (!dialog) return; // no modal on this page — navigate normally
    e.preventDefault();
    openModal(dialog, link.href);
    return;
  }

  const dialog = getDialog();
  if (!dialog?.open) return;

  if (target.closest("#privacy-modal-close")) {
    dialog.close();
    return;
  }

  // Backdrop click: ::backdrop clicks register on the <dialog> itself; the
  // inner panel fills the dialog box (p-0), so target === dialog ⇔ outside.
  if (target === dialog) dialog.close();
});
